import { Eyebrow, TitleBar } from './atoms'
import { useLang, t } from '../lib/lang'
import type { VideoEntry } from '../lib/types'

function VideoCard({ v }: { v: VideoEntry }) {
  return (
    <div>
      <div style={{
        position: 'relative', aspectRatio: '16 / 9',
        overflow: 'hidden', background: 'var(--ink)',
        boxShadow: 'var(--shadow-2)',
      }}>
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${v.youtube_id}`}
          title={v.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
        />
      </div>
      <div style={{ marginTop: 16 }}>
        <div style={{
          fontFamily: 'var(--font-display)', fontWeight: 500,
          textTransform: 'uppercase', letterSpacing: '0.04em',
          fontSize: 20, lineHeight: 1.15, color: 'var(--fg)',
        }}>{v.title}</div>
        {v.description && (
          <p style={{
            fontFamily: 'var(--font-body)', fontSize: 14, lineHeight: 1.55,
            color: 'var(--fg-muted)', margin: '10px 0 0', maxWidth: 520,
          }}>{v.description}</p>
        )}
      </div>
    </div>
  )
}

export function Videos({ items }: { items: VideoEntry[] }) {
  const { lang } = useLang()
  if (!items.length) return null
  const cols = Math.min(2, items.length)
  return (
    <section id="videos" className="ax-pad-section" style={{ background: 'var(--paper)', padding: '120px 48px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div className="ax-header-row" style={{
          display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
          marginBottom: 64, gap: 40, flexWrap: 'wrap',
        }}>
          <div>
            <Eyebrow>{t(lang, 'section_videos_eyebrow')}</Eyebrow>
            <TitleBar size={56}>{t(lang, 'section_videos_title')}</TitleBar>
          </div>
          <p style={{
            fontFamily: 'var(--font-body)', fontSize: 15, lineHeight: 1.6,
            color: 'var(--fg-muted)', maxWidth: 380, margin: 0,
          }}>{t(lang, 'section_videos_intro')}</p>
        </div>

        <div className="ax-grid-videos" style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 40 }}>
          {items.map((v) => <VideoCard key={v.id} v={v} />)}
        </div>
      </div>
    </section>
  )
}
